import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import api from 'client';

export default () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('labels');
  const bookAppointment = async (data) => api.post(`/apis/v2/patient/bookings/book_appointment`, data);
  const requestAppointment = async (data) => api.post(`/apis/v2/patient/bookings/request_appointment`, data);

  const bookAppointmentMutation = useMutation(bookAppointment, {
    onSuccess: () => {
      toast(t('request_sent'));

      queryClient.removeQueries({
        predicate: ({ queryKey }) => queryKey[0] === 'GET' && queryKey[1] === `/apis/v2/patient/bookings/provider_availabilities`,
      });
      queryClient.invalidateQueries(['GET', `/apis/v2/appointments`, {}]);
    },
    onError: () => {
      toast.error(() => (
        <div>
          {t('appointment_timeslot_not_available')}
          <Typography variant="caption" component="p">
            {t('please_book_another_timeslot')}
          </Typography>
        </div>
      ));
    },
  });

  const requestAppointmentMutation = useMutation(requestAppointment, {
    onSuccess: () => {
      toast(t('request_sent'));
    },
    onError: () => {
      toast.error(() => (
        <div>
          {t('appointment_timeslot_not_available')}
          <Typography variant="caption" component="p">
            {t('please_book_another_timeslot')}
          </Typography>
        </div>
      ));
    },
  });

  return {
    bookAppointment: bookAppointmentMutation.mutateAsync,
    requestAppointment: requestAppointmentMutation.mutateAsync,
  };
};
